import { Component } from '@angular/core';

import { faCog, faPoll, faQuestionSquare, faSignOutAlt } from '@fortawesome/pro-solid-svg-icons';

/**
 * Main page header
 *
 * @export
 * @class HeaderComponent
 * @implements {OnInit}
 */
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent {
  /**
   * Sign out icon
   *
   * @memberof HeaderComponent
   */
  faSignOutAlt = faSignOutAlt;

  /**
   * Admin icon
   *
   * @memberof HeaderComponent
   */
  faCog = faCog;

  /**
   * Indicates whether the menu is currently expanded, in mobile mode
   *
   * @memberof HeaderComponent
   */
  isExpanded = false;

  /**
   * Reports icon.
   *
   * @memberof HeaderComponent
   */
  faPoll = faPoll;

  /**
   * Help icon.
   *
   * @memberof HeaderComponent
   */
  faQuestionSquare = faQuestionSquare;

  /**
   * Toggle the menu, in mobile mode
   *
   * @memberof HeaderComponent
   */
  toggle() {
    this.isExpanded = !this.isExpanded;
  }
}
